import { NormalizedNumber, raise } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'
import { TokenDefinition } from '@/domain/types/TokenDefinition'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

interface TokenRepositoryBase<T extends TokenDefinition = Token> {
  all(): T[]
  findBySymbol(symbol: TokenSymbol): T | undefined
  findOneBySymbol(symbol: TokenSymbol): T
  findOneBalance(symbol: TokenSymbol): NormalizedNumber
  findOneBalanceOrZero(symbol: TokenSymbol): NormalizedNumber
}
export type TokenRepository = TokenRepositoryBase<Token>
export interface TokenDefinitionRepository {
  all(): TokenDefinition[]
  findBySymbol(symbol: TokenSymbol): TokenDefinition | undefined
  findOneBySymbol(symbol: TokenSymbol): TokenDefinition
}

export function createTokenDefinitionRepository(tokens: TokenDefinition[]): TokenDefinitionRepository {
  const tokenList = tokens

  function all(): TokenDefinition[] {
    return tokenList
  }
  function findBySymbol(_symbol: TokenSymbol): TokenDefinition | undefined {
    return tokenList.find(({ symbol }) => symbol === _symbol)
  }
  function findOneBySymbol(symbol: TokenSymbol): TokenDefinition {
    return findBySymbol(symbol) ?? raise(`Token with symbol ${symbol} not found`)
  }

  return {
    all,
    findBySymbol,
    findOneBySymbol,
  }
}
